<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
        ></go-lotus-side-menu>

        <div class="col-12 col-md-10">
            <div class="row pt-3 p-sm-1" v-cloak>
                <div class="col-12 col-lg-6">
                    <div class="p-1 p-sm-4">
                        <photo-upload-widget
                            :user="user"
                            :profile-status="profileCompletion.profile_statu"
                        ></photo-upload-widget>
                    </div>
                    <div class="p-1 p-sm-4">
                        <welcome-progress-widget
                            :user="user"
                            :to-do="[]"
                            :profile-completion="profileCompletion.profile_completion"
                        ></welcome-progress-widget>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <welcome-golotus-widget></welcome-golotus-widget>
                </div>
            </div>
            <div class="row pt-3 p-sm-1">
                <div class="col-12">
                    <company-documents :organization="organization"></company-documents>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";

import PhotoUploadWidget from "./widgets/PhotoUploadWidget";
import WelcomeProgressWidget from "./dashboard/WelcomeProgressWidget";
import AccountGlanceWidget from "./dashboard/AccountGlanceWidget";
import CenterNewsWidget from "./dashboard/CenterNewsWidget";
import CenterMonthWidget from "./dashboard/CenterMonthWidget";
import WelcomeGolotusWidget from "./widgets/WelcomeGolotusWidget";

import { sideMenuItems } from "../plugins/sideMenuItems";
import CompanyDocuments from "./control-center/CompanyDocuments";

export default {
    name: "Account",
    props: ["user", "organization", "profileCompletion"],
    mixins: [sideMenuItems],
    components: {
        CompanyDocuments,
        GoLotusSideMenu,
        PhotoUploadWidget,
        WelcomeProgressWidget,
        AccountGlanceWidget,
        CenterNewsWidget,
        CenterMonthWidget,
        WelcomeGolotusWidget,
    },
    data() {
        return {};
    },
    mounted() {},
    watch: {
        user() {
            if (this.user) {
                mixpanel.identify(this.user.id);
                mixpanel.people.set({
                    $first_name: this.user.first_name,
                    $last_name: this.user.last_name,
                    $created: this.user.created_at,
                    $email: this.user.email,
                    "Golotus Super User": this.user.is_super_user === 0 ? false : true,
                });
            }
        },
    },
    methods: {},
};
</script>

<style scoped></style>
